Currency = require 'models/currency.coffee'

class Virtual
  @className: 'Virtual'
  constructor: (obj, user) ->
    _.merge(@, obj)
    @name = 'Reserves' if @isRS() and HM.is_english
    return @
  universalBalance: (convert_to_currency) -> Currency.convert(@balance, @currency, convert_to_currency)
  fUniversalBalance: ->
    Currency.format
      value: @universalBalance(HM.store.getters.default_currency)
      currency: HM.store.getters.default_currency

  isGoal: -> @subtype == 'saving'
  isFund: -> @subtype == 'budget'
  isHM:   -> @subtype == 'hm'
  isRS:   -> @subtype == 'rs'

  fSubtype: ->
    return 'goal' if @isGoal()
    return 'fund' if @isFund()
    return 'rs'   if @isRS()
    return 'hm'   if @isHM()

  isNew: -> _.isNil(@id)

  saved_amount: ->
    res = @balance
    res += @spent if @isGoal()
    res = Math.round(res) if Currency.get(@currency).precision == 0
    res
  saved_percent: ->
    return 0 if @saved_amount() == 0
    res = Math.round(@saved_amount() / @aim * 100)
    res = 0 if not _.isNumber(res) or res < 0
    res = 100 if res > 100
    res

  needed_to_save: ->
    val = @aim - @saved_amount()
    val = Math.round(val) if Currency.get(@currency).precision == 0
    val = 0 if val < 0
    val

  needed_to_save_every_month: ->
    return 0 unless @goal_finish_date
    return 0 unless @isGoal()
    res = Math.round @needed_to_save() / (hm_date.differenceInDays(@goal_finish_date, new Date) / 30)
    return 0 unless _.isNumber(res)
    return _.min [res, @needed_to_save()]
    return res

  name_and_balance: -> return "#{@name} (#{@fBalance()})"
  fBalance: ->
    Currency.format
      value: @balance
      currency: (@currency)

  @newRecord: (user) ->
    attrs =
      id: null
      name: ''
      balance: 0
      type: "goal"
      currency: user.userdata.default_currency
      aim: 0.0
      goal_finish_date: null
      goal_type: null
      goal_status: null
      position: 0
      hidden: false
      spent: 0
      subtype: "saving"
      description: ''
    new Virtual(attrs)



class HoneyMoney extends Virtual
  constructor: (args) ->
    @id       = -1
    @name     = if HM.is_russian then 'ХаниМани' else 'HoneyMoney'
    @balance  = args.balance
    @currency = args.currency
    @subtype  = 'hm'

# class Reserves extends Virtual
# class Goal extends Virtual
# class Fund extends Virtual

module.exports =
  Virtual    : Virtual
  HoneyMoney : HoneyMoney
  # Reserves   : Reserves
  # Fund       : Fund
  # Goal       : Goal
